export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_2.c1ac8e1c.jpg";